import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PaymentStatus } from '@domain/models';

@Component({
  selector: 'app-payment-result-generic',
  templateUrl: './payment-result-generic.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentGenericResultComponent {
  readonly status = input<PaymentStatus | null>(null);
}
